import { ConfigurationService } from "@oel/js-configuration";

export class GabaritNavigationUtil {
    private static estSessionLegacyCharge = false;
    private static estAfficherTiroirPrimeurs = ConfigurationService.getConfig("oel-contexte-applicatif") === "ADP";
    private static estAfficherMenuDroite = true;
    private static estMenuDroiteEpuree = false;
    private static identifiantMenuDroiteActif = ConfigurationService.getConfig("oel-contexte-applicatif") === "ADP" ? '' : 'menudroiteaccueilada';
    private static identifiantAideContact = this.obtenirIdentifiantAideContact();

    static obtenirConfigurationGabarit() {
        return {
            typeGabarit: 'consultation',
            consultation: {
                filAriane: [],
                afficherAideContact: true,
                afficherSondageCaisse: !this.estMenuDroiteEpuree,
                afficherLogoAssuranceDepot: !this.estMenuDroiteEpuree,
                afficherLiensUtiles: !this.estMenuDroiteEpuree,
                afficherMenuDroite: this.estAfficherMenuDroite,
                estSessionLegacyCharge: this.estSessionLegacyCharge,
                afficherTiroirPrimeurs: this.estAfficherTiroirPrimeurs,
                idContenuPrincipal: "titre-page-pour-retour-contenu-principal",
                entetePage: {
                    identifiantMenu: this.obtenirIdentifiantEntete(),
                },
                idsEnvoyerEvenement: ["accueil", "recherche-transaction"],
                estContexteN3: false,
                menuPrincipal: {
                    identifiantMenu: this.identifiantMenuDroiteActif
                },
                aideContactV2: {
                    identifiantMenu: this.identifiantAideContact
                }
            },
        };
    }

    static afficherGabaritAccueilADA() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(false),
            this.obtenirConfigurationsAfficherMenuDroite(true),
            this.obtenirConfigurationsAvecMenuDroiteEpuree(false),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
            this.obtenirConfigurationsAvecIdentifiantMenuDroite('menudroiteaccueilada'),
        ));
    }

    static afficherGabaritAccueilADP() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(true),
            this.obtenirConfigurationsAfficherMenuDroite(true),
            this.obtenirConfigurationsAvecMenuDroiteEpuree(false),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
            this.obtenirConfigurationsAvecIdentifiantMenuDroite(''),
        ));
    }

    static afficherGabaritPageDetailsEOPADA() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(false),
            this.obtenirConfigurationsAfficherMenuDroite(true),
            this.obtenirConfigurationsAvecMenuDroiteEpuree(true),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
            this.obtenirConfigurationsAvecIdentifiantMenuDroite('menudroitedetailcompteada'),
        ));
    }

    static afficherGabaritPageDetailsEOPADP() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(false),
            this.obtenirConfigurationsAfficherMenuDroite(true),
            this.obtenirConfigurationsAvecMenuDroiteEpuree(true),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
            this.obtenirConfigurationsAvecIdentifiantMenuDroite('menu-compact-droite-adp'),
        ));
    }

    static afficherGabaritStandard() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(false),
            this.obtenirConfigurationsAfficherMenuDroite(false),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
        ));
    }

    static afficherGabaritPageDetailsMargeCredit() {
        this.envoyerConfigurationGabarit(this.deepMergeObjects(
            this.obtenirConfigurationsReinitialisationFilAriane(),
            this.obtenirConfigurationsTiroirPrimeurs(false),
            this.obtenirConfigurationsAfficherMenuDroite(true),
            this.obtenirConfigurationsAvecMenuDroiteEpuree(true),
            this.obtenirConfigurationsAideContact(this.obtenirIdentifiantAideContact()),
            this.obtenirConfigurationsAvecIdentifiantMenuDroite('menu-compact-droite-adp'),
        ));
    }

    static declencherSessionLegacyCharge() {
        if (!this.estSessionLegacyCharge) {
            this.estSessionLegacyCharge = true;
            this.envoyerConfigurationGabarit({
                detail: {
                    consultation: {
                        estSessionLegacyCharge: this.estSessionLegacyCharge
                    }
                }
            });
        }
    }

    private static obtenirIdentifiantEntete() {
        return ConfigurationService.getConfig("oel-contexte-applicatif") === "ADP"
            ? "entete-consultation-adp-principal-accueil"
            : undefined;
    }

    private static obtenirIdentifiantAideContact() {
        return ConfigurationService.getConfig("oel-contexte-applicatif") === "ADP"
            ? "aidecontact"
            : "aidecontact-ada";
    }

    private static obtenirConfigurationsAfficherMenuDroite(afficherMenuDroite: boolean) {
        if (this.estAfficherMenuDroite !== afficherMenuDroite) {
            this.estAfficherMenuDroite = afficherMenuDroite;
            return {
                detail: {
                    consultation: {
                        afficherMenuDroite: this.estAfficherMenuDroite,
                    }
                }
            };
        }
        return {};
    }

    private static obtenirConfigurationsAvecMenuDroiteEpuree(estMenuDroiteEpuree: boolean) {
        if (this.estMenuDroiteEpuree !== estMenuDroiteEpuree) {
            this.estMenuDroiteEpuree = estMenuDroiteEpuree;
            return {
                detail: {
                    consultation: {
                        afficherSondageCaisse: !this.estMenuDroiteEpuree,
                        afficherLogoAssuranceDepot: !this.estMenuDroiteEpuree,
                        afficherLiensUtiles: !this.estMenuDroiteEpuree,
                    }
                }
            };
        }
        return {};
    }

    private static obtenirConfigurationsAideContact(identifiantAideContact: string) {

        if (this.identifiantAideContact !== identifiantAideContact) {
            this.identifiantAideContact = identifiantAideContact;

            return {
                detail: {
                    consultation: {
                        aideContactV2: {
                            identifiantMenu: this.identifiantAideContact
                        }
                    }
                }
            };
        }
        return {};
    }

    private static obtenirConfigurationsAvecIdentifiantMenuDroite(identifiantMenu: string) {

        if (this.identifiantMenuDroiteActif !== identifiantMenu) {
            this.identifiantMenuDroiteActif = identifiantMenu;

            return {
                detail: {
                    consultation: {
                        menuPrincipal: {
                            identifiantMenu: this.identifiantMenuDroiteActif,
                        }
                    }
                }
            };
        }
        return {};
    }

    private static obtenirConfigurationsReinitialisationFilAriane() {
        return {
            detail: {
                consultation: {
                    filAriane: []
                }
            }
        };
    }

    private static obtenirConfigurationsTiroirPrimeurs(afficherTiroirPrimeurs: boolean) {
        if (this.estAfficherTiroirPrimeurs !== afficherTiroirPrimeurs) {
            this.estAfficherTiroirPrimeurs = afficherTiroirPrimeurs;
            return {
                detail: {
                    consultation: {
                        afficherTiroirPrimeurs: afficherTiroirPrimeurs
                    }
                }
            };
        }
        return {};
    }

    private static envoyerConfigurationGabarit(configuration: any) {
        dispatchEvent(
            new CustomEvent("@navigation-gabarit/v1/appliquer-configuration", configuration)
        );
    }

    private static deepMergeObjects(target, ...sources) {
        if (!sources.length) return target;

        const source = sources.shift();

        if (typeof target === 'object' && typeof source === 'object') {
            for (const key in source) {
                if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                    if (!target[key] || typeof target[key] !== 'object') {
                        target[key] = {};
                    }
                    this.deepMergeObjects(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
        }

        return this.deepMergeObjects(target, ...sources);
    }
}
